import Class from './c-chart-stacked';
import './c-chart-stacked@.vue';

export default Class;